import React, { useEffect, useState } from 'react';
import { Row, Col } from 'reactstrap';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classes from './Dashboard.module.scss';
import JumbotronMenuItem from '../../components/JumbotronMenuItem/JumbotronMenuItem';
import OfferPromoModal from './dashboard/OfferPromoModal';
import { connect } from 'react-redux';

const CardLink = (props) => {
  const { link, title, icon } = props;
  return (
    <Link to={link} className={classes.noDecoration}>
      <div className={classes.dashboardButton}>
        <div>
          <FontAwesomeIcon fixedWidth icon={icon} />
        </div>
        <div>{title}</div>
      </div>
    </Link>
  );
};

const Dashboard = (props) => {
  const [isVisitHelperOpen, setIsVisitHelperOpen] = useState(false);
  const [isVisitHelperVisible, setIsVisitHelperVisible] = useState(false);

  useEffect(() => {
    const appearTimer = window.setTimeout(() => {
      setIsVisitHelperVisible(true);
    }, 1200);

    return () => {
      window.clearTimeout(appearTimer);
    };
  }, []);

  return (
    <React.Fragment>
      <div className={classes.dashboardRoot}>
        <div className={classes.dashboardContent}>
          {props.isAuthenticated && props.tvp && (
            <React.Fragment>
              <Row>
                <Col xs={6} md={3}>
                  <CardLink
                    link="/12c05bd7-624b-4f6f-b5d3-436c4c2b87e9"
                    title="Wnioski 2026-2028"
                    icon="file-signature"
                  />
                </Col>
                <Col xs={6} md={3}>
                  <CardLink
                    link="/d01a278e-75ae-48e9-a602-268f36cf282b"
                    title="Wnioski 2022-2025"
                    icon="file-signature"
                  />
                </Col>
                <Col xs={6} md={3}>
                  <CardLink
                    link="/6acf6808-690d-4b4b-acc0-f872ec4f97d7"
                    title="Moje deklaracje"
                    icon="file-invoice"
                  />
                </Col>
                <Col xs={6} md={3}>
                  <CardLink
                    link="/e512472b-b254-4127-9183-4ce840d76b71"
                    title="Reklamacje i refundacje"
                    icon="envelope"
                  />
                </Col>
                {/* <Col xs={6} md={3}>
              <CardLink
                link="/77b0aff4-5429-4f4a-9ecb-c33faf739739"
                title="Moje dane"
                icon="user-edit"
              />
            </Col> */}
              </Row>
            </React.Fragment>
          )}
          <Row className={classes.mobileVisitRow}>
            <Col xs="12">
              <div className={classes.mobileVisitInfo}>
                <div className={classes.mobileVisitTitle}>
                  Jak umówić wizytę?
                </div>
                <p>
                  Telefonicznie (24/7): <b>22 505 15 48</b>, <b>799 698 698</b>,{' '}
                  <b>801 405 905</b>.
                </p>
                <p>
                  Portal Pacjenta:{' '}
                  <a
                    href="https://moje.pzu.pl/cas/login"
                    target="_blank"
                    rel="noopener noreferrer">
                    moje.pzu.pl
                  </a>
                  .
                </p>
                <p>
                  Problem z kontem? Zadzwoń: <b>22 566 50 07</b> (wybierz tonowo
                  5).
                </p>
              </div>
            </Col>
          </Row>
          <Row className={classes.offerRow}>
            <Col xs="12">
              <a
                className={classes.offerBanner}
                target="_blank"
                rel="noopener noreferrer"
                href="https://tvp.uspartner.pl"
                style={{ backgroundColor: '#243a69' }}>
                <span className={classes.offerBadge}>
                  Prywatne ubezpieczenia
                </span>
                <span className={classes.offerText}>
                  {/* Ubezpieczenia dobrowolne dla pracowników i współpracowników TVP */}
                  <span className={classes.offerHighlight}>
                    OBNIŻONE STAWKI
                  </span>{' '}
                  na Podroże Zagraniczne, Moto Assistance Europa, NNW, <br />
                  Pakiety weterynaryjne dla psa i kota i inne
                </span>
                <span className={classes.offerCta}>Sprawdź szczegóły</span>
              </a>
            </Col>
          </Row>
          <Row className={classes.sectionRow}>
            <Col>
              <h3 className={classes.sectionTitle}>Ubezpieczenia zdrowotne</h3>
            </Col>
          </Row>

          <Row>
            <JumbotronMenuItem
              urlPrefix="pracownicy2026"
              insuranceName="Pracownicy"
              img="30"
              // hasBorder
            />
            <JumbotronMenuItem
              urlPrefix="wspolpracownicy2026"
              insuranceName2="Współpracownicy / byli pracownicy do 67 r. życia"
              img="40"
              // hasBorder
            />
          </Row>

          <Row>
            <JumbotronMenuItem
              urlPrefix="senior2026"
              insuranceName2="Senior / byli pracownicy powyżej 67 r. życia"
              img="8"
              // hasBorder
            />
            <JumbotronMenuItem
              urlPrefix="dorosleDziecko2026"
              insuranceName="Dorosłe Dziecko"
              img="7"
              // hasBorder
            />
          </Row>
        </div>
        <div
          className={`${classes.visitHelper} ${
            isVisitHelperVisible ? classes.visitHelperVisible : ''
          } ${isVisitHelperOpen ? classes.visitHelperOpen : ''}`}>
          <button
            type="button"
            className={classes.visitHelperToggle}
            aria-expanded={isVisitHelperOpen}
            onClick={() => setIsVisitHelperOpen((prev) => !prev)}>
            <span className={classes.helperBang}>!</span>
            <span>Jak umówić wizytę?</span>
          </button>
          <div className={classes.visitHelperPanel}>
            <div className={classes.visitHelperTitle}>Szybka pomoc</div>
            <p>
              Telefonicznie (24/7): <br />
              <b>22 505 15 48</b>, <br />
              <b>799 698 698</b>, <br />
              <b>801 405 905</b>.
            </p>
            <p>
              Portal Pacjenta:{' '}
              <a
                href="https://moje.pzu.pl/cas/login"
                target="_blank"
                rel="noopener noreferrer">
                moje.pzu.pl
              </a>
              .
            </p>
            <p className={classes.helperNote}>
              Problem z kontem? Zadzwoń: <b>22 566 50 07</b> (wybierz tonowo 5).
            </p>
          </div>
        </div>
      </div>
      <br />
      {/* <Row>
      <JumbotronMenuItem
        urlPrefix={'pracownicy'}
        insuranceName={'TVP Pracownicy'}
        img={'1'}
        disabledButton
        hasBorderOld
      />
      <JumbotronMenuItem
        urlPrefix={'wspolpracownicy'}
        insuranceName={'TVP Współpracownicy'}
        img={'2'}
        disabledButton
        hasBorderOld
      />
    </Row>
    <Row>
      <JumbotronMenuItem
        urlPrefix={'senior'}
        insuranceName={'Senior'}
        img={'8'}
        disabledButton
        hasBorderOld
      />
      <JumbotronMenuItem
        urlPrefix={'dorosleDziecko'}
        insuranceName={'Dorosłe Dziecko'}
        img={'7'}
        disabledButton
        hasBorderOld
      />
    </Row> */}
      <OfferPromoModal />
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  const programs = state.auth.programs || [];
  return {
    isAuthenticated: state.auth.token !== null,

    username: state.auth.user.name,
    tvp: state.auth.user.programId === '7651f192-5247-4a85-9ed3-5e510bf96167',
    hasPrograms: programs.length > 1 ? true : false,
    menu: state.menu.data && state.menu.data.menu ? state.menu.data.menu : []
  };
};

// const mapDispatchToProps = (dispatch) => {
//     return {
//         logout: () => dispatch(logout())
//     };
// }

export default connect(
  mapStateToProps
  // mapDispatchToProps
)(Dashboard);
